import { render, staticRenderFns } from "./addPositionDialog.vue?vue&type=template&id=35f80ae3"
import script from "./addPositionDialog.vue?vue&type=script&lang=js"
export * from "./addPositionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports